import { NoEmail } from "models";
import { api } from ".";

const url = "/tasks";

const sendEmailAPI = api.injectEndpoints({
	endpoints: (build) => ({
		createSendEmails: build.mutation<void, Record<string, any>>({
			query: (data) => {
				return {
					url: `${url}/send-email`,
					method: "POST",
					body: data,
				};
			},
			invalidatesTags: (result, error, { id }) => {
				return error ? [] : [{ type: "users", id }];
			},
		}),
		createRemindEmails: build.mutation<void, Record<string, any>>({
			query: (data) => {
				return {
					url: `${url}/remind-email`,
					method: "POST",
					body: data,
				};
			},
			invalidatesTags: (result, error, { id }) => {
				return error ? [] : [{ type: "users", id }];
			},
		}),
		getUserNoEmail: build.query<NoEmail[], void>({
			query: () => `${url}/no-email`,
		}),
	}),
});
export const { useCreateSendEmailsMutation, useCreateRemindEmailsMutation, useLazyGetUserNoEmailQuery } = sendEmailAPI;
